export const environment = {

  pageDescription: 'Книги на русском в Греции; Книги в наличии и под заказ; VARËNKA - это европейский книжный проект, в котором собраны волшебные истории, созданные потрясающими авторами и талантливыми иллюстраторами современности, мировая классика в самых лучших изданиях, книги об искусстве, познавательная и иностранная литература для детей и взрослых.',
  pageTitle: 'VARENKA - книги на русском в Греции; книжный магазин в Афинах, Греция; книги в наличии и под заказ',

  deliveryTypeNames:{
    "pickup_from_warehouse": 'Самовывоз в Афинах',
    "pick_point": 'Самовывоз из пункта выдачи',
    "postamat_delivery": 'Доставка в постамат',
    "courier_delivery": 'Доставка курьером на дом',
    "mail_delivery": 'Доставка почтой по Греции',
    "mail_delivery_europe": 'Доставка почтой по Европе',
  },

  taxesName: 'AFM',

  errors: {
    fieldError: 'Некорректное значение поля',
    concentDataProcessingError:'Поле не может быть пустым',
    deliveryTypeError:'Поле не может быть пустым',
    nameError:'Поле не может быть пустым',
    emailNullableError:'Поле не может быть пустым',
    latinNameError:'Поле не может быть пустым',
    emailCorrectError: 'Некорректный email',
    phoneNullableError:'Поле не может быть пустым',
    phoneCorrectError: 'Некорректный телефон',
    mask: 'Некорректный телефон',
    postalCodeError:'Поле не может быть пустым',
    countryError:'Поле не может быть пустым',
    cityError:'Поле не может быть пустым',
    pickPointError:'Поле не может быть пустым',
    customerExist: "Вы уже подписаны на рассылку",
    responseError: "Произошла ошибка, попробуйте повторить опзднее",
    max: 'Некорректное значение поля',
    postamatIdNullableError: "Поле не может быть пустым",
    postamatAddressNullableError: "Поле не может быть пустым",

  },

    coverTypes: {
      board_book: "Книжка-картонка",
      hard_cover: "Твердая обложка",
      soft_cover: "Мягкая обложка",

    },

  stripe: {
    publicKey: 'pk_live_51SaelOJ7IPTzv3dWHrUVr5vQl7diJWbmxCjEjPzpXCpKxudlBFgOLDIbEnBGekRbQhfDB2NdcoHtG02ZDHaK7dv500P8OQuFZN',
  },

  dns: "https://varenkabooks.gr/",

  shopAddress:
    {
      address: "Dousmani 3, Glifada 166 75",
      link: "https://www.google.com/maps/place/TeoBooks/@37.861888,23.7496357,20.5z/data=!4m6!3m5!1s0x14a1bf2176f57f55:0xca324dc03807c0d2!8m2!3d37.8619818!4d23.7494063!16s%2Fg%2F11ycjs38mj?entry=ttu&g_ep=EgoyMDI1MTExNy4wIKXMDSoASAFQAw%3D%3D"
    },
  instagram: 'https://www.instagram.com/teobookshop.ath/',
  telegram: 'https://t.me/varenka_books',

  email: 'varenka.books@gmail.com',
  legalInfo: 'Empresário em Nome Individual, Daria Dombrova, Número fiscal 313 283 834',
  certificateImage: '../../../assets/certificates/certificate_vertical.png',
  reclamationInfo: '<a href="https://www.livroreclamacoes.pt/" class="footer-menu-item" target="_blank">Dispomos de livro de reclamações</a>',
  reclamationLinc: '',
  showReclamation: false,

  countries: ['pt', 'gr'],
  countryNames: {
    pt: "Португалия",
    gr: "Греция"
  },

  url: "https://varenkabooks.",

  countryUrls: {
      pt: "com",
      gr: "gr"
  },
  library: false,
  libraryCategoryNames: {},

  mainImages: [
    '/assets/main-gr/cover_rgb_web_2800x1200.jpg',
    '/assets/main-gr/varenka-gr.jpg'
  ]


};
